export enum OpportunityType {
    Offer = 'Offer',
    Request = 'Request'
}